import { InternalPage, Spacer } from 'theSource/components';
import { BackLink } from 'enrollment/components';
import {
  CardStyled,
  CardContentStyled,
  PageWrapperStyled,
} from './PrivacyPolicyStyled';
import { PrivacyPolicyTables } from './components';
import { privacyPolicyText } from 'theSource/assets';
import { ROUTES } from 'theSource/app/routes';

export const PrivacyPolicyDisplay = () => {
  return (
    <>
      <BackLink
        underline={false}
        testId="back-button"
        className="mb-4"
        defaultPath={`${ROUTES.public.legalDocuments.path}/`}
      />
      <InternalPage title={privacyPolicyText.title}>
        <Spacer height={6} />
        <PageWrapperStyled data-testid="privacy-policy-read-only">
          <CardStyled>
            <CardContentStyled>
              {Object.entries(privacyPolicyText)
                .slice(2)
                .map(([key, value]) => (
                  <PrivacyPolicyTables key={key} data={value} />
                ))}
            </CardContentStyled>
          </CardStyled>
        </PageWrapperStyled>
      </InternalPage>
    </>
  );
};
